module.exports = __webpack_public_path__ + "media/svg/ky-75bc4d4f.svg";